var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1857 7.09286C13.1857 8.43739 12.7493 9.67939 12.014 10.6871L15.7225 14.3984C16.0886 14.7646 16.0886 15.3592 15.7225 15.7254C15.3563 16.0915 14.7617 16.0915 14.3955 15.7254L10.6871 12.014C9.67939 12.7522 8.43739 13.1857 7.09286 13.1857C3.72714 13.1857 1 10.4586 1 7.09286C1 3.72714 3.72714 1 7.09286 1C10.4586 1 13.1857 3.72714 13.1857 7.09286ZM7.09286 11.311C9.42162 11.311 11.311 9.42162 11.311 7.09286C11.311 4.7641 9.42162 2.87473 7.09286 2.87473C4.7641 2.87473 2.87473 4.7641 2.87473 7.09286C2.87473 9.42162 4.7641 11.311 7.09286 11.311Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearchIcon);
export default __webpack_public_path__ + "static/media/white_search_icon.bde9d47e2692dff4c154e711f21d8964.svg";
export { ForwardRef as ReactComponent };